export enum ProjectFileSystemType {
  Folder,
  File
}
